import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { map, Observable, of } from 'rxjs';
import { IEmployee } from '../employee';
import {EmployeeService} from "../services/employee.service";

@Injectable({
  providedIn: 'root'
})
export class EmployeeResolver  {
  constructor(private employeeService: EmployeeService) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<IEmployee> {
    const id = route.paramMap.get("id");
    return this.employeeService.getEmployee(id);
  }
}
